import { useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { formatVal } from '../../../../../../helpers/value'
import { selectScoreRanges } from '../../../../../common/header/companyInfo/store/slice'
import { selectActiveTab } from '../../store/slice'
import { ScoreTooltip } from './ScoreTooltip'

export const ScoreCell = ({ data }) => {
  const activeTab = useSelector(selectActiveTab)
  const scoreRanges = useSelector(selectScoreRanges(activeTab))
  const locale = useSelector((state) => state.i18n.locale)

  const { color = '#CCCCCC' } =
    scoreRanges.find(
      (item) =>
        data?.value <= item['scoreRange_Max'] &&
        data?.value >= item['scoreRange_Min'],
    ) || {}

  return (
    <div className="dFlex justifyContentCenter">
      <Element
        className="dFlex justifyContentCenter alignItemsCenter fw600"
        style={{ backgroundColor: color, width: 60 }}
      >
        {formatVal(data?.value, locale, false, 0)}
        <ScoreTooltip publicDate={data?.publicDate} />
      </Element>
    </div>
  )
}
